import React, { useEffect } from "react";
import { useState } from "react";
import { ChallengeHeader, commonConstant } from "../../../../common";
import { CHALLENGE, DASHBOARD_HEADER, QUIZ_HEADER } from "../../../../common/challengeConstants";
import './ChallengeMyDashboardHeader.scss';
import { getDataFromSession } from "../../../../utill.func";

const ChallengeMyDashboardHeader = ({ challengeDate, badgeClassname, handleTeamDashboardRedirection, handleHomeRedirection, showRectBadge}) => {

    const challengeData = getDataFromSession('challengeData');
    const eventType = challengeData?.eventType;
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const windowTop = window.scrollY;
            setIsSticky(windowTop > 30);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])

    return (
        <div className={`my-dashboard-header-wrapper ${isSticky ? 'sticky' : ''}`}>
            <ChallengeHeader 
                leftIcon={DASHBOARD_HEADER.LEFT_ICON}
                badgeClassname={badgeClassname}
                challengeDate={challengeDate}
                rightIcon={eventType?.toUpperCase() !== CHALLENGE.type.ME && QUIZ_HEADER.RIGHT_ICON}
                isHeaderSticky={isSticky}
                leftIconRedirect={handleHomeRedirection}
                rightIconRedirect={handleTeamDashboardRedirection}
                showRectBadge={showRectBadge}
                />
        </div>
    )
}

export default ChallengeMyDashboardHeader;